import { Col, Container, Row } from 'react-grid-system'
import { NavTabsProps, NavTabsWithActions } from '../molecules'
import { useState } from 'react'
import { UserProfileDetailTemplate } from '../templates'
import { useUserLanguage } from '@/customHooks'
import textsData from '@/textData/UserProfileTexts.json'

export const UserProfilePage = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es.tabs : textsData.en.tabs

  const [selectedTab, setSelectedTab] = useState('1')


  const tabs: NavTabsProps[] = [
    {
      label: texts.tab1,
      id: '1'
    },
    {
      label: texts.tab2,
      id: '2'
    },
    {
      label: texts.tab3,
      id: '3'
    },
  ]

  return (
    <>
      <Row>
        <Col>
          <NavTabsWithActions
            tabs={tabs}
            onClick={setSelectedTab}
            selectedTabId={selectedTab}
          />
        </Col>
      </Row>
      <Container>
        <UserProfileDetailTemplate selectedSection={selectedTab} />
      </Container>
    </>
  )
}